import {
    Box,
    Grid,
    Paper,
    Typography,
    Button,
    Stack,
} from "@mui/material";
import useTitle from "hooks/useTitle";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AddMcaV3CredGlasse from "views/settings/organization/OrganizationProfile/Mca/AddMcaV3CredGlasse";
import { alerttt } from "assets";
import { ResType } from "types";
import { QueryFunctionContext, useQuery } from "react-query";
import { getMcaV3Credentials } from "api/services/organization";

const McaDashboard = () => {
    useTitle("ATOM Pro | MCA");
    const navigate = useNavigate();
    const [open, setOpen] = useState<boolean>(false);
    const { data: mcaCredentials, isLoading: mcaCredentialsLoading }: ResType = useQuery(
        "org-mca-credentials",
        getMcaV3Credentials
      );
    const isMcaConnected = (mcaCredentials?.data?.mcaV3UserId && mcaCredentials?.data?.mcaV3Password) ? true : false;

    return (
        <Box m={3}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6" mb={2}>
                        MCA Dashboard
                    </Typography>
                </Grid>

                {!isMcaConnected && (
                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 4,
                                borderRadius: "22px",
                                position: "relative",
                                overflow: "hidden",
                                color: "#fff",

                                background: "linear-gradient(135deg, #9b3d02 0%, #9c3a00 100%)",

                                boxShadow: `
      0 15px 40px rgba(156,58,0,0.45)
    `,

                                border: "1px solid rgba(255,140,0,0.35)",

                                transition: "all 0.25s ease",

                                "&:hover": {
                                    transform: "translateY(-3px)",
                                    boxShadow: `
        0 20px 50px rgba(156,58,0,0.55)
      `,
                                },
                            }}
                        >

                            <Stack
                                direction={{ xs: "column", md: "row" }}
                                alignItems={{ md: "center" }}
                                justifyContent="space-between"
                                spacing={3}
                            >
                                <Stack direction="row" spacing={2.5} alignItems="flex-start">
                                    <Box
                                        sx={{
                                            width: 56,
                                            height: 56,
                                            borderRadius: "16px",
                                            position: "relative",
                                            overflow: "hidden", // 🔥 IMPORTANT
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",

                                            background: "rgba(255, 255, 255, 0.08)",
                                            backdropFilter: "blur(18px)",
                                            WebkitBackdropFilter: "blur(18px)",
                                            border: "1px solid rgba(255,255,255,0.18)",

                                            boxShadow: `
      0 6px 20px rgba(0,0,0,0.12),
      inset 0 1px 0 rgba(255,255,255,0.35)
    `,
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={alerttt}
                                            alt="MCA Logo"
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover", // 🔥 makes it fill perfectly
                                            }}
                                        />
                                    </Box>

                                    <Box>
                                        <Typography variant="h6" fontWeight={700}>
                                            MCA V3 Portal Not Connected
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mt: 0.5,
                                                opacity: 0.85,
                                                maxWidth: 650,
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            To use MCA API services and file forms directly to the portal,
                                            you need to add your MCA V3 login credentials. This is a
                                            one-time secure setup with OTP verification.
                                        </Typography>

                                        <Button
                                            variant="contained"
                                            sx={{
                                                mt: 2.5,
                                                px: 3,
                                                py: 1,
                                                textTransform: "none",
                                                fontWeight: 600,
                                                borderRadius: "10px",
                                                background:
                                                    "linear-gradient(135deg, #3b82f6, #2563eb)",
                                                boxShadow: "0 6px 20px rgba(37,99,235,0.45)",
                                                "&:hover": {
                                                    transform: "translateY(-2px)",
                                                    boxShadow: "0 8px 24px rgba(37,99,235,0.6)",
                                                },
                                                transition: "all 0.25s ease",
                                            }}
                                            onClick={() => setOpen(true)}
                                        >
                                            🔐 Add MCA Credentials Now
                                        </Button>
                                        <AddMcaV3CredGlasse open={open} setOpen={setOpen} />
                                    </Box>
                                </Stack>

                                {/* Right Button */}
                                <Button
                                    variant="outlined"
                                    sx={{
                                        color: "#fff",
                                        borderColor: "rgba(255,255,255,0.35)",
                                        textTransform: "none",
                                        fontWeight: 500,
                                        borderRadius: "10px",
                                        px: 3,
                                        backdropFilter: "blur(6px)",
                                        background: "rgba(255,255,255,0.05)",
                                        "&:hover": {
                                            background: "rgba(255,255,255,0.15)",
                                            borderColor: "#fff",
                                        },
                                    }}
                                    onClick={() => navigate("/settings/organization-profile")}
                                >
                                    Go to Settings →
                                </Button>
                            </Stack>
                        </Paper>
                    </Grid>
                )}

            </Grid>
        </Box>
    );
};

export default McaDashboard;

